<div class="mb-3">
  <h2>{{ 'COMPANY_ACCOUNT.REVIEW_COMPANY_INFORMATION' | translate }}</h2>
  <div>{{ 'COMPANY_ACCOUNT.REVIEW_COMPANY_INFORMATION_DESCRIPTION' | translate }}</div>
</div>
<div class="px-4 py-3">
  <div class="row">
    <div class="col-6">
      <div class="mb-3">
        <h3>{{ 'COMPANY_ACCOUNT.COMPANY_INFORMATION' | translate }}</h3>
        <hr />
        <div class="d-flex flex-column gap-2">
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.COMPANY_NAME' | translate }}:</div>
            <div class="w-50">{{ company.name || '-' }}</div>
          </div>
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.COMPANY_REGISTRATION_NUMBER' | translate }}:</div>
            <div class="w-50">{{ company.code || '-' }}</div>
          </div>
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.VAT_REGISTRATION_NUMBER' | translate }}:</div>
            <div class="w-50">{{ company.vatCode || '-' }}</div>
          </div>
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.REGISTERED_ADDRESS' | translate }}:</div>
            <div class="w-50">{{ company.address || '-' }}</div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <h3>{{ 'COMPANY_ACCOUNT.BANK_INFORMATION' | translate }}</h3>
        <hr />
        <div class="d-flex flex-column gap-2">
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.BANK_NAME' | translate }}:</div>
            <div class="w-50">{{ company.bank || '-' }}</div>
          </div>
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.BANK_ACCOUNT_NUMBER' | translate }}:</div>
            <div class="w-50">{{ company.iban || '-' }}</div>
          </div>
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.BIC_SWIFT' | translate }}:</div>
            <div class="w-50">{{ company.swift || '-' }}</div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <h3>{{ 'COMPANY_ACCOUNT.CONTACT_INFORMATION' | translate }}</h3>
        <hr />
        <div class="d-flex flex-column gap-2">
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.REPRESENTATIVE' | translate }}:</div>
            <div class="w-50">{{ company.representative || '-' }}</div>
          </div>
          <div class="d-flex py-1">
            <div class="w-50">{{ 'COMPANY_ACCOUNT.CONTACT_INFORMATION_FOR_CORRESPONDENCE' | translate }}:</div>
            <div class="w-50">{{ company.correspondence || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
        <h3>{{ 'COMPANY_ACCOUNT.MARKET_MANAGER' | translate }}</h3>
        <hr />
        <div class="d-flex gap-3 mb-4">
          <div>
            <div
              class="rounded-circle marketing-manager-avatar"
              [attr.aria-label]="company.marketManagerFullName"
            ></div>
          </div>
          <div class="d-flex flex-column gap-1">
            <h4 class="m-0">{{ company.marketManagerFullName ?? '-' }}</h4>
            <div class="d-flex flex-wrap gap-4">
              <div class="d-flex gap-2">
                <i class="icon ni-email"></i>
                <a href="mailto:{{ company.marketManagerEmail }}">{{ company.marketManagerEmail ?? '-' }}</a>
              </div>
              <div class="d-flex gap-2">
                <i class="icon ni-call"></i>
                <span>{{ company.marketManagerPhone ?? '-' }}</span>
              </div>
            </div>
          </div>
        </div>
        <app-alert variant="gray" [closeable]="false">
          {{ 'COMPANY_ACCOUNT.MARKET_MANAGER_DISCLAIMER' | translate }}
        </app-alert>
      </div>
    </div>
  </div>
</div>
